/**
 * @author      Shivani Mehra
 * @date        Oct, 2025
 * @copyright   www.ibirdsservices.com
 */
import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Image,
  Row,
  Table,
  OverlayTrigger,
  Popover,
} from 'react-bootstrap';
import WatconnectApi from '../../../api/WatconnectApi';
import DataApi from '../../../api/DataApi';
import { ToastContainer, toast } from 'react-toastify'; // npm i react-toastify --force
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import CountryCode from '../../../constants/CountryCode';
import * as constants from '../../../constants/CONSTANT';
const MarketingTemplate = ({
  previewData,
  selectedWhatsAppSetting,
  selectedCategory,
}) => {
  const initialFormData = {
    id: '',
    name: '',
    templatename: '',
    language: '',
    status: '',
    category: '',
    header: '',
    header_text: '',
    header_image_url: '',
    header_document_url: '',
    header_video_url: '',
    message_body: '',
    footer: '',
    buttons: [],
  };

  const navigate = useNavigate();
  const [isSending, setIsSending] = useState(false);
  const [isSpinner, setIsSpinner] = useState(false);
  const [rowData, setRowData] = useState(initialFormData);
  const [buttons, setButtons] = useState([]);
  // file
  const [selectedFiles, setSelectedFiles] = useState();
  const [errorMessage, setErrorMessage] = useState('');
  const [selectedImage2, setSelectedImage2] = useState();
  const [selectedDocument2, setSelectedDocument2] = useState();
  const [selectedVideo2, setSelectedVideo2] = useState();
  const [errors, setErrors] = useState({});
  const watconnectApi = new WatconnectApi('webhook_template');
  const dataApi = new DataApi('watconnect');

  const bodyRef = useRef(null);
  const countryList = [
    '+971',
    '+93',
    '+355',
    '+374',
    '+244',
    '+54',
    '+43',
    '+61',
    '+994',
    '+880',
    '+32',
    '+226',
    '+359',
    '+973',
    '+257',
    '+229',
    '+673',
    '+591',
    '+55',
    '+267',
    '+375',
    '+1',
    '+242',
    '+41',
    '+225',
    '+56',
    '+237',
    '+86',
    '+57',
    '+506',
    '+420',
    '+49',
    '+45',
    '+213',
    '+593',
    '+372',
    '+20',
    '+291',
    '+34',
    '+251',
    '+358',
    '+33',
    '+241',
    '+44',
    '+995',
    '+594',
    '+233',
    '+220',
    '+30',
    '+502',
    '+245',
    '+852',
    '+504',
    '+385',
    '+509',
    '+36',
    '+62',
    '+353',
    '+972',
    '+91',
    '+964',
    '+39',
    '+962',
    '+81',
    '+254',
    '+855',
    '+82',
    '+965',
    '+856',
    '+961',
    '+94',
    '+231',
    '+266',
    '+370',
    '+352',
    '+371',
    '+218',
    '+212',
    '+377',
    '+373',
    '+261',
    '+389',
    '+223',
    '+95',
    '+976',
    '+222',
    '+356',
    '+265',
    '+52',
    '+60',
    '+258',
    '+264',
    '+227',
    '+234',
    '+505',
    '+31',
    '+47',
    '+977',
    '+64',
    '+968',
    '+507',
    '+51',
    '+675',
    '+63',
    '+92',
    '+48',
    '+351',
    '+595',
    '+974',
    '+40',
    '+381',
    '+7',
    '+250',
    '+966',
    '+249',
    '+46',
    '+65',
    '+386',
    '+421',
    '+232',
    '+221',
    '+252',
    '+211',
    '+503',
    '+268',
    '+235',
    '+228',
    '+66',
    '+992',
    '+993',
    '+216',
    '+886',
    '+255',
    '+380',
    '+256',
    '+598',
    '+998',
    '+58',
    '+84',
    '+967',
    '+27',
    '+26',
  ];

  useEffect(() => {
    if (previewData && previewData?.category === selectedCategory) {
      let exampleBodyText = [];
      if (previewData.example_body_text) {
        try {
          const parsed =
            typeof previewData.example_body_text === 'string'
              ? JSON.parse(previewData.example_body_text)
              : previewData.example_body_text;
          if (Array.isArray(parsed) && parsed.length > 0) {
            exampleBodyText = Array.isArray(parsed[0]) ? parsed[0] : parsed;
          }
        } catch (e) {
          console.error('Error parsing example_body_text', e);
        }
      }

      const expectedMaxPlaceholder = exampleBodyText.length;

      const updatedExamples = Array.from(
        { length: expectedMaxPlaceholder },
        (_, index) => ({
          placeholder: index + 1,
          value: exampleBodyText[index] || '',
        })
      );

      setRowData(prevData => ({
        ...prevData,
        message_body: rowData.message_body,
        message_body_example: updatedExamples,
      }));
      const buttons =
        previewData?.buttons?.length > 0
          ? previewData.buttons.map(button => {
              const btn = {
                type: button.type,
                text: button.text,
              };

              if (button.type === 'PHONE_NUMBER' && button.phone_number) {
                const matchedCode = countryList.find(code =>
                  button.phone_number.startsWith(code)
                );
                if (matchedCode) {
                  btn.country_code = matchedCode;
                  btn.phone_number = button.phone_number.replace(
                    matchedCode,
                    ''
                  );
                } else {
                  btn.phone_number = button.phone_number;
                  btn.country_code = '';
                }
              }

              if (button.type === 'URL') {
                btn.url = button.url;
              }

              if (button.type === 'QUICK_REPLY') {
                btn.text = button.text;
              }

              return btn;
            })
          : [];

      setRowData({
        id: previewData?.type === 'clone' ? '' : previewData?.id || '',
        name: '',
        language: previewData?.language || '',
        status: previewData?.status || '',
        category: previewData?.category || '',
        header: previewData?.header || '',
        header_text: previewData?.header_text || '',
        header_image_url: previewData?.header_image_url || '',
        header_document_url: previewData?.header_document_url || '',
        header_video_url: previewData?.header_video_url || '',
        message_body: previewData?.message_body || '',
        message_body_example: updatedExamples || null,
        footer: previewData?.footer || '',
        buttons,
      });

      setButtons(buttons);
      setSelectedImage2(previewData?.header_image_url || null);
      setSelectedDocument2(previewData?.header_document_url || null);
      setSelectedVideo2(previewData?.header_video_url || null);
      // setSelectedFiles(previewData?.header_image_url || null)
    } else {
      setRowData(initialFormData);
      setButtons([]);
      setSelectedFiles(null);
    }
  }, [previewData]);
  const addVariable = () => {
    const existingExamples = rowData?.message_body_example || [];

    const newExample = {
      placeholder: existingExamples.length + 1,
      value: '',
    };
    const updatedExamples = [...existingExamples, newExample];
    setRowData(prevData => ({
      ...prevData,
      message_body_example: updatedExamples,
      message_body:
        `${prevData?.message_body} {{${existingExamples.length + 1}}} ` || '',
    }));
  };
  useEffect(() => {
    if (!rowData?.message_body) {
      setRowData(prevData => ({
        ...prevData,

        //message_body_example: null,
      }));
      return;
    }

    //const textarea = bodyRef.current;
    //const startPosition = textarea.selectionStart;
    //const endPosition = textarea.selectionEnd;
    const placeholders = Array.from(
      new Set(rowData.message_body.match(/{{\d+}}/g) || [])
    ).map(val => parseInt(val.match(/\d+/)[0]));

    if (placeholders.length > 0) {
      placeholders.sort((a, b) => a - b);

      const maxPlaceholder = Math.max(...placeholders);
      const expectedMaxPlaceholder = placeholders.length;

      if (maxPlaceholder !== expectedMaxPlaceholder) {
        const placeholderMap = new Map(
          placeholders.map((val, index) => [val, index + 1])
        );
        rowData.message_body = rowData.message_body.replace(
          /{{\d+}}/g,
          match => `{{${placeholderMap.get(parseInt(match.match(/\d+/)[0]))}}}`
        );
      }

      const existingExamples = rowData?.message_body_example || [];
      const exampleMap = existingExamples.reduce((map, example) => {
        map[example.placeholder] = example.value;
        return map;
      }, {});

      const updatedExamples = Array.from(
        { length: expectedMaxPlaceholder },
        (_, index) => ({
          placeholder: index + 1,
          value: exampleMap[index + 1] || '',
        })
      );

      setRowData(prevData => ({
        ...prevData,
        message_body: rowData.message_body,
        message_body_example: updatedExamples,
      }));
    } else {
      setRowData(prevData => ({
        ...prevData,
        message_body_example: null,
      }));
    }
  }, [rowData?.message_body]);

  const handleChange = event => {
    const { name, value } = event.target;

    const textarea = bodyRef.current;
    const cursorPos = textarea.selectionStart;

    let updatedValue = value;

    if (name === 'message_body' && updatedValue === '') {
      setRowData(prevData => ({ ...prevData, message_body_example: null }));
    }
    setRowData(prevData => ({ ...prevData, [name]: updatedValue }));

    if (name === 'header') {
      setSelectedFiles(null);
      setSelectedImage2(null);
      setSelectedDocument2(null);
      setSelectedVideo2(null);
      setErrorMessage('');
    }

    setTimeout(() => {
      textarea.selectionStart = textarea.selectionEnd = cursorPos;
    }, 0);
  };

  const handleFileChange = event => {
    const { name, files } = event.target;
    const file = files[0];

    if (!file) return;

    const fileTypeMappings = {
      header_image_url: ['jpg', 'jpeg', 'png'],
      header_document_url: [
        'pdf',
        'txt',
        'xls',
        'xlsx',
        'doc',
        'docx',
        'ppt',
        'pptx',
      ],
      header_video_url: ['mp4'],
    };

    const fileSize = {
      header_image_url: 5,
      header_document_url: 100,
      header_video_url: 16,
    };

    const validExtensions = fileTypeMappings[name];
    if (!validExtensions.includes(file.name.split('.').pop().toLowerCase())) {
      setErrorMessage(`Only ${validExtensions.join(', ')} files are allowed.`);
      event.target.value = '';
      return;
    }

    const validSize = fileSize[name];
    if (file.size > validSize * 1024 * 1024) {
      setErrorMessage(`Exceed maximum allowed upload size of ${validSize}MB.`);
      event.target.value = '';
      return;
    }

    setErrorMessage('');
    switch (name) {
      case 'header_image_url':
        setSelectedImage2(null);
        setSelectedFiles(file);
        break;
      case 'header_document_url':
        setSelectedDocument2(null);
        setSelectedFiles(file);
        break;
      case 'header_video_url':
        setSelectedVideo2(null);
        setSelectedFiles(file);
        break;
      default:
        break;
    }
  };
  const validateForm = () => {
    let newErrors = {};

    // Template name
    if (!rowData?.name?.trim()) {
      newErrors.name = 'Template name is required.';
    } else if (rowData.name.length > 512) {
      newErrors.name = 'Template name must not exceed 512 characters.';
    }

    // Language
    if (!rowData?.language) {
      newErrors.language = 'Language is required.';
    }

    // Header validation
    if (rowData?.header === 'TEXT') {
      if (!rowData?.header_text?.trim()) {
        newErrors.header_text = 'Header text is required.';
      } else if (rowData.header_text.length > 60) {
        newErrors.header_text = 'Header text must not exceed 60 characters.';
      }
    }

    // Header media validation
    if (rowData?.header === 'IMAGE') {
      if (!selectedFiles && !selectedImage2) {
        newErrors.header_image_url = 'Image attachment is required.';
      }
    } else if (rowData?.header === 'VIDEO') {
      if (!selectedFiles && !selectedVideo2) {
        newErrors.header_video_url = 'Video attachment is required.';
      }
    } else if (rowData?.header === 'DOCUMENT') {
      if (!selectedFiles && !selectedDocument2) {
        newErrors.header_document_url = 'Document attachment is required.';
      }
    }

    // Body validation
    if (!rowData?.message_body?.trim()) {
      newErrors.message_body = 'Body is required.';
    } else if (
      rowData.message_body.length < 25 ||
      rowData.message_body.length > 1024
    ) {
      newErrors.message_body = 'Body must be between 25 and 1024 characters.';
    } else if (/\{\{\d+\}\}$/.test(rowData.message_body.trim())) {
      newErrors.message_body = 'Body cannot end with a variable.';
    }

    // Body variables example
    if (rowData?.message_body_example?.length) {
      rowData.message_body_example.forEach(example => {
        if (!example.value?.trim()) {
          newErrors[`body_var_${example.placeholder}`] =
            `Value for {{${example.placeholder}}} is required.`;
        }
      });
    }

    // Footer validation
    if (rowData?.footer && rowData.footer.length > 60) {
      newErrors.footer = 'Footer must not exceed 60 characters.';
    }

    // Buttons validation
    buttons.forEach((button, idx) => {
      if (!button.type) {
        newErrors[`button_${idx}_type`] = 'Button type is required.';
      }

      if (button.type === 'QUICK_REPLY') {
        if (!button.text?.trim()) {
          newErrors[`button_${idx}_text`] = 'Quick reply text is required.';
        } else if (button.text.length > 25) {
          newErrors[`button_${idx}_text`] =
            'Quick reply must not exceed 25 characters.';
        }
      }

      if (button.type === 'URL') {
        if (!button.text?.trim()) {
          newErrors[`button_${idx}_text`] = 'Button text is required.';
        }
        if (!button.url?.trim()) {
          newErrors[`button_${idx}_url`] = 'URL is required.';
        } else if (!/^https?:\/\/.+/.test(button.url)) {
          newErrors[`button_${idx}_url`] =
            'URL must be valid (start with http/https).';
        }
      }

      if (button.type === 'PHONE_NUMBER') {
        if (!button.text?.trim()) {
          newErrors[`button_${idx}_text`] = 'Button text is required.';
        }
        if (!button.phone_number?.trim()) {
          newErrors[`button_${idx}_phone`] = 'Phone number is required.';
        } else if (!/^\d{7,15}$/.test(button.phone_number)) {
          newErrors[`button_${idx}_phone`] =
            'Phone number must be 7–15 digits.';
        }
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async event => {
    if (!validateForm()) return; // show errors, don’t submit
    setIsSpinner(true);

    event.preventDefault();

    if (rowData.header === 'TEXT' && !rowData.header_text.trim()) {
      toast.error('Template header text is required.');
      return;
    }

    if (buttons.length > 0) {
      for (const button of buttons) {
        if (
          button.type === 'URL' &&
          (!button.text.trim() || !button.url.trim())
        ) {
          toast.error('Please fill in all fields for the URL button.');
          return;
        }
        if (
          button.type === 'PHONE_NUMBER' &&
          (!button.text.trim() || !button.phone_number.trim())
        ) {
          toast.error('Please fill in all fields for the Phone Number button.');
          return;
        }
        if (button.type === 'QUICK_REPLY' && !button.text.trim()) {
          toast.error('Please fill in all fields for the quick reply button.');
          return;
        }
      }
    }

    let imageId = '';
    let filesToUpload = selectedFiles;

    if (
      !filesToUpload &&
      ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(rowData.header)
    ) {
      const existingUrl =
        selectedImage2 ||
        selectedVideo2 ||
        selectedDocument2 ||
        rowData?.header_image_url ||
        rowData?.header_document_url ||
        rowData?.header_video_url;

      if (existingUrl) {
        try {
          const apiBase = constants.API_BASE_URL ? constants.API_BASE_URL.replace(/\/+$/, '') : '';
          const fullUrl = existingUrl.startsWith('http')
            ? existingUrl
            : `${apiBase}${existingUrl.startsWith('/') ? '' : '/'}${existingUrl}`;
          const response = await fetch(fullUrl);
          if (response.ok) {
            const blob = await response.blob();
            const filename = existingUrl.split('/').pop().split('?')[0] || 'attachment';
            filesToUpload = new File([blob], filename, {
              type: blob.type || 'application/octet-stream',
            });
          }
        } catch (err) {
          console.warn('Could not fetch existing attachment for Meta upload session:', err);
        }
      }
    }

    if (filesToUpload) {
      const formData = new FormData();
      formData.append('files', filesToUpload);

      const sessionId = await watconnectApi.post(
        `?whatsapp_setting_number=${selectedWhatsAppSetting}`,
        formData
      );

      if (sessionId?.id) {
        const formData2 = new FormData();
        formData2.append('files', filesToUpload);
        formData2.append('uploadSessionId', sessionId.id);

        const document = await watconnectApi.post(
          `/uploadsessionid?whatsapp_setting_number=${selectedWhatsAppSetting}`,
          formData2
        );

        imageId = document?.h || '';
      }
    }

    const formattedName = rowData.name
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');

    const reqBody = {
      name: formattedName,
      language: rowData.language,
      category: selectedCategory,
      components: [
        ...(rowData.header
          ? [
              {
                type: 'HEADER',
                format: rowData.header,
                ...(rowData.header === 'TEXT' && { text: rowData.header_text }),
                ...(rowData.header === 'IMAGE' && {
                  example: {
                    header_handle: [imageId || rowData?.header_image_url],
                  },
                }),
                ...(rowData.header === 'DOCUMENT' && {
                  example: {
                    header_handle: [imageId || rowData?.header_document_url],
                  },
                }),
                ...(rowData.header === 'VIDEO' && {
                  example: {
                    header_handle: [imageId || rowData?.header_video_url],
                  },
                }),
              },
            ]
          : []),
        {
          type: 'BODY',
          text: rowData?.message_body,
          ...(rowData.message_body?.match(/\{\{(\d+)\}\}/g) && {
            example: {
              body_text: [
                Object.values(rowData?.message_body_example).map(
                  data => data.value
                ),
              ],
            },
          }),
        },
        ...(rowData.footer
          ? [
              {
                type: 'FOOTER',
                text: rowData.footer,
              },
            ]
          : []),
        ...(buttons.filter(button => button.text && button.type).length > 0
          ? [
              {
                type: 'BUTTONS',
                buttons: buttons
                  .filter(button => button.text && button.type)
                  .map(button => ({
                    type: button.type,
                    text: button.text,
                    ...(button.type === 'PHONE_NUMBER' && {
                      phone_number: `${button.country_code || '+91'}${
                        button.phone_number
                      }`,
                    }),
                    ...(button.type === 'URL' && { url: button.url }),
                  })),
              },
            ]
          : []),
      ],
    };

    try {
      setIsSpinner(true);
      let result;
      result = await watconnectApi.post(
        `/template?whatsapp_setting_number=${selectedWhatsAppSetting}`,
        reqBody
      );

      if (result?.error) {
        const { error_user_msg, message, body } = result.error;

        const errorMessage = `
                    ${error_user_msg ? `• ${error_user_msg}\n` : ''}
                    ${message ? `• ${message}\n` : ''}
                    ${body ? `• ${body}` : ''}
                `.trim();

        toast.error(errorMessage);
      } else {
        const marketingdb = await dataApi.post(`/template`, {
          template_id: result?.id, // from Meta API response
          template_name: formattedName,
          language: rowData.language,
          category: result?.category,
          header: rowData.header,
          header_body: rowData.header_text || null,
          message_body: rowData.message_body,
          footer: rowData.footer,
          buttons: buttons,
          business_number: selectedWhatsAppSetting,
          cards: null,
          template_type: result?.category,
          status: result?.status,
          example_body_text: rowData?.message_body_example
            ? rowData.message_body_example.map(item => item.value)
            : [],
        });
        if (marketingdb?.error) {
          toast.error(marketingdb.error.message || 'DB Save error');
          setIsSending(false);
          return;
        }
        const marketingData = marketingdb?.data?.data || marketingdb;

        const fileForAttachment = selectedFiles || filesToUpload;
        if (marketingData?.id && fileForAttachment) {
          const attachmentsApi = new DataApi('attachments');

          const fileForm = new FormData();
          fileForm.append('files', fileForAttachment);
          fileForm.append(
            'description',
            `${formattedName} file for WatConnect`
          );
          const attachmentRes = await attachmentsApi.post(
            `/${marketingData?.id}`,
            fileForm
          );
          console.log(attachmentRes);
        }
        console.log('marketingdb', marketingdb);
        toast.success(
          rowData?.id
            ? 'Template updated successfully.'
            : 'Template created successfully.'
        );
        setIsSpinner(false);
        navigate('/watconnect/templates');
      }
    } catch (error) {
      toast.error('An unexpected error occurred.');
    } finally {
      setIsSending(false);
      setIsSpinner(false);
    }
  };

  const handleBack = () => {
    navigate('/watconnect/templates');
  };

  const handleRemoveButton = index => {
    const updatedButtons = buttons.filter((_, i) => i !== index);
    setButtons(updatedButtons);
  };

  const handleAddButton = () => {
    const quickReplyCount = buttons.filter(
      button => button.type === 'QUICK_REPLY'
    ).length;
    const hasPhone = buttons.some(button => button.type === 'PHONE_NUMBER');
    const hasUrl = buttons.some(button => button.type === 'URL');

    if (buttons.length < 5) {
      if (!hasPhone && !hasUrl) {
        const newButton = {
          type: 'PHONE_NUMBER',
          text: '',
          phone_number: '',
          url: '',
        };
        setButtons([...buttons, newButton]);
      } else if (!hasPhone && hasUrl) {
        const newButton = {
          type: 'PHONE_NUMBER',
          text: '',
          phone_number: '',
          url: '',
        };
        setButtons([...buttons, newButton]);
      } else if (hasPhone && !hasUrl) {
        const newButton = { type: 'URL', text: '', phone_number: '', url: '' };
        setButtons([...buttons, newButton]);
      } else {
        if (quickReplyCount < 3) {
          const newQuickReplyButton = {
            type: 'QUICK_REPLY',
            text: '',
            phone_number: '',
            url: '',
          };
          setButtons([...buttons, newQuickReplyButton]);
        } else {
          toast.error('Maximum of 3 Quick Reply buttons can be added.');
        }
      }
    } else {
      toast.error('Maximum of 5 buttons can be added.');
    }
  };

  const handleButtonChange = (index, field, value) => {
    const updatedButtons = buttons.map((button, i) => {
      if (i === index) {
        return { ...button, [field]: value };
      }
      return button;
    });
    setButtons(updatedButtons);
  };

  const getDisabledOptions = currentType => {
    const hasPhone = buttons.some(button => button.type === 'PHONE_NUMBER');
    const hasUrl = buttons.some(button => button.type === 'URL');
    if (
      (currentType === 'PHONE_NUMBER' && hasPhone) ||
      (currentType === 'URL' && hasUrl)
    ) {
      return true;
    }
    return false;
  };
  const isFormValid =
    Boolean(rowData?.name?.trim()) &&
    Boolean(rowData?.language) &&
    Boolean(rowData?.message_body?.trim()) &&
    rowData?.message_body?.trim()?.length >= 25 &&
    // Boolean(rowData?.footer?.trim()) &&
    (Array.isArray(rowData?.message_body_example)
      ? rowData.message_body_example.every(
          item =>
            item &&
            typeof item === 'object' &&
            'placeholder' in item &&
            Boolean(item.placeholder) &&
            'value' in item &&
            typeof item.value === 'string' &&
            Boolean(item.value.trim())
        )
      : true);

  const formatTextArea = character => {
    if (!bodyRef.current) return;
    let text = rowData?.message_body || '';
    const textarea = bodyRef.current;
    const startPosition = textarea.selectionStart;
    const endPosition = textarea.selectionEnd;
    character = character.trim();
    const selectedText = text.substring(startPosition, endPosition);
    const newText =
      text.substring(0, startPosition) +
      character +
      selectedText +
      character +
      text.substring(endPosition);
    setRowData(prevData => ({ ...prevData, message_body: newText }));

    setTimeout(() => {
      textarea.selectionStart = startPosition + character.length;
      textarea.selectionEnd = endPosition + character.length;
      textarea.focus();
    }, 0);
  };

  const helpText = (
    <ul>
      <li>
        Variable parameters are missing or have mismatched curly braces. The
        correct format is \u007B\u007B1\u007D\u007D.
      </li>
      <li>
        Variable parameters contain special characters such as #, $, or %.
      </li>
      <li>
        Variable parameters are not sequential. For example,
        \u007B\u007B1\u007D\u007D, \u007B\u007B2\u007D\u007D,
        \u007B\u007B4\u007D\u007D, \u007B\u007B5\u007D\u007D are defined but
        \u007B\u007B3\u007D\u007D does not exist.
      </li>
      <li>
        Template contains too many variable parameters relative to the message
        length. You need to decrease the number of variable parameters or
        increase the message length.
      </li>
      <li>The message template cannot end with a parameter.</li>
    </ul>
  );

  // Remove a variable and renumber all variables in message_body and message_body_example
  const handleRemoveVariable = placeholderToRemove => {
    // Remove the variable from message_body_example
    let updatedExamples = (rowData.message_body_example || []).filter(
      item => item.placeholder !== placeholderToRemove
    );

    // Remove the corresponding {{n}} and any surrounding whitespace from message_body
    let updatedBody = rowData.message_body.replace(
      new RegExp(`\\s*\\{\\{${placeholderToRemove}\\}\\}\\s*`, 'g'),
      ' '
    );
    // Collapse multiple spaces and trim
    updatedBody = updatedBody.replace(/ +/g, ' ').trim();

    // Renumber all variables in message_body and message_body_example sequentially
    let placeholders = Array.from(
      new Set(updatedBody.match(/{{\d+}}/g) || [])
    ).map(val => parseInt(val.match(/\d+/)[0]));
    placeholders.sort((a, b) => a - b);

    const placeholderMap = new Map();
    placeholders.forEach((oldNum, idx) => {
      placeholderMap.set(oldNum, idx + 1);
    });

    let renumberedBody = updatedBody.replace(/{{\d+}}/g, match => {
      const oldNum = parseInt(match.match(/\d+/)[0]);
      return `{{${placeholderMap.get(oldNum)}}}`;
    });

    let renumberedExamples = updatedExamples.map((item, idx) => ({
      ...item,
      placeholder: idx + 1,
    }));

    setRowData(prevData => ({
      ...prevData,
      message_body: renumberedBody,
      message_body_example:
        renumberedExamples.length > 0 ? renumberedExamples : null,
    }));
  };

  return (
    <>
      {!isSpinner ? (
        <>
          <Container className='mt-1'>
            <Row className='mx-5 g-0'>
              <Col lg={12} sm={12} xs={12}>
                <Card className='h-100' style={{ border: 'none' }}>
                  <Card.Body>
                    <Row>
                      <Col lg={12} sm={12} xs={12}>
                        <Form.Group className='mx-2 mb-3'>
                          <Form.Label
                            className='form-view-label'
                            htmlFor='formBasicName'
                          >
                            <b>Template name and language</b>
                          </Form.Label>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className='mb-3'>
                      <Col lg={6} sm={12} xs={12}>
                        <Form.Group className='mx-2 mb-3'>
                          <Form.Label
                            className='form-view-label'
                            htmlFor='formBasicTemplateName'
                          >
                            Template Name
                          </Form.Label>
                          <Form.Control
                            // disabled={rowData?.id}
                            type='text'
                            name='name'
                            value={rowData?.name}
                            onChange={handleChange}
                            placeholder='Enter template name'
                            required
                            isInvalid={!!errors.name}
                          />
                          <Form.Control.Feedback type='invalid'>
                            {errors.name}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col lg={6} sm={12} xs={12}>
                        <Form.Group className='mb-2 mx-3'>
                          <Form.Label
                            className='form-view-label'
                            htmlFor='formBasicLanguage'
                          >
                            Language
                          </Form.Label>
                          <Form.Select
                            // disabled={rowData?.id}
                            aria-label='select language'
                            name='language'
                            value={rowData?.language}
                            onChange={handleChange}
                            required
                            isInvalid={!!errors.language}
                          >
                            <option value=''>Select Language</option>
                            <option value='en'>English</option>
                            <option value='en_US'>English (US)</option>
                            <option value='en_GB'>English (UK)</option>
                            <option value='hi'>Hindi</option>
                            <option value='ur'>Urdu</option>
                          </Form.Select>
                          <Form.Control.Feedback type='invalid'>
                            {errors.language}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>

          <Container className='mt-1'>
            <Row className='mx-5 mb-5 g-0'>
              <Col lg={12} sm={12} xs={12} className='mb-2'>
                <Card className='h-100' style={{ border: 'none' }}>
                  <Card.Body>
                    <Row>
                      <Col lg={12} sm={12} xs={12}>
                        <Form.Group className='mx-2 mb-3'>
                          <Form.Label
                            className='form-view-label'
                            htmlFor='formBasicContent'
                          >
                            <b>Content </b> ( Fill in the header, body and
                            footer sections of your template. )
                          </Form.Label>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className='mb-3'>
                      <Col lg={6} sm={12} xs={12}>
                        <Form.Group className='mb-3 mx-3'>
                          <Form.Label
                            className='form-view-label'
                            htmlFor='formBasicHeader'
                          >
                            Header
                          </Form.Label>
                          <Form.Select
                            aria-label='select language'
                            name='header'
                            value={rowData?.header}
                            onChange={handleChange}
                          >
                            <option value=''>Select Header</option>
                            <option value='TEXT'>Text</option>
                            <option value='IMAGE'>Image</option>
                            <option value='DOCUMENT'>Document</option>
                            <option value='VIDEO'>Video</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      {rowData.header === 'TEXT' && (
                        <Col lg={6} sm={12} xs={12}>
                          <Form.Group className='mx-3 mb-3'>
                            <div className='d-flex justify-content-between align-items-center'>
                              <div className='d-flex align-items-center'>
                                <Form.Label
                                  className='form-view-label mb-0'
                                  htmlFor='formBasicHeaderText'
                                >
                                  Header Text
                                </Form.Label>
                                <OverlayTrigger
                                  placement='auto'
                                  overlay={
                                    <Popover id={`popover-positioned-auto`}>
                                      <Popover.Body>
                                        <ul className='mb-0'>
                                          <li>Max 60 characters.</li>
                                          <li>
                                            No new lines, emojis, or special
                                            characters.
                                          </li>
                                        </ul>
                                      </Popover.Body>
                                    </Popover>
                                  }
                                >
                                  <i
                                    className='fa-solid fa-circle-info text-secondary ms-2'
                                    style={{ cursor: 'pointer' }}
                                  ></i>
                                </OverlayTrigger>
                              </div>

                              <span
                                className='text-muted'
                                style={{ fontSize: '0.85rem' }}
                              >
                                {`${rowData?.header_text?.length || 0}/60`}
                              </span>
                            </div>

                            <Form.Control
                              type='text'
                              name='header_text'
                              value={rowData?.header_text}
                              onChange={handleChange}
                              placeholder='Enter text here...'
                              required
                              maxLength={60}
                              isInvalid={!!errors.header_text}
                            />
                            <Form.Control.Feedback type='invalid'>
                              {errors.header_text}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      )}
                    </Row>

                    <Row className='mb-3'>
                      <Col lg={6} sm={12} xs={12}>
                        {rowData.header === 'IMAGE' && (
                          <>
                            <Form.Group className='mb-3 mx-3'>
                              <Form.Label>Upload Image</Form.Label>{' '}
                              <Form.Text muted>
                                (Image Supported: .jpg, .jpeg, .png)
                              </Form.Text>
                              <Form.Control
                                type='file'
                                name='header_image_url'
                                accept='image/jpeg, image/png, image/jpg' // Allow only image files
                                onChange={handleFileChange}
                                isInvalid={!!errors.header_image_url}
                              />
                              <Form.Control.Feedback type='invalid'>
                                {errors.header_image_url}
                              </Form.Control.Feedback>
                              <Form.Text>Maximum Size: 5MB</Form.Text>
                              {errorMessage && (
                                <>
                                  <br />
                                  <Form.Text className='text-danger'>
                                    {errorMessage}
                                  </Form.Text>
                                </>
                              )}
                            </Form.Group>
                            {selectedImage2 ? (
                              <Image
                                className='mx-3'
                                variant='top'
                                src={selectedImage2}
                                thumbnail
                                style={{ width: '15%' }}
                              ></Image>
                            ) : (
                              selectedFiles && (
                                <Image
                                  className='mx-3'
                                  variant='top'
                                  src={URL.createObjectURL(selectedFiles)}
                                  thumbnail
                                  style={{ width: '15%' }}
                                ></Image>
                              )
                            )}
                          </>
                        )}

                        {rowData.header === 'DOCUMENT' && (
                          <>
                            <Form.Group className='mb-3 mx-3'>
                              <Form.Label>Upload Document</Form.Label>{' '}
                              <Form.Text muted></Form.Text>
                              <Form.Control
                                type='file'
                                name='header_document_url'
                                accept='.pdf,.txt,.xls,.xlsx,.doc,.docx,.ppt,.pptx' // Allow supported document files
                                onChange={handleFileChange}
                                isInvalid={!!errors.header_document_url}
                              />
                              <Form.Control.Feedback type='invalid'>
                                {errors.header_document_url}
                              </Form.Control.Feedback>
                              <Form.Text>
                                Maximum Size: 100MB. Supported: pdf, txt, xls,
                                xlsx, doc, docx, ppt, pptx
                              </Form.Text>
                              {errorMessage && (
                                <>
                                  <br />
                                  <Form.Text className='text-danger'>
                                    {errorMessage}
                                  </Form.Text>
                                </>
                              )}
                            </Form.Group>

                            {selectedDocument2 ? (
                              <Form.Text className='text-muted mx-2'>
                                <a
                                  href={selectedDocument2}
                                  target='_blank'
                                  rel='noopener noreferrer'
                                >
                                  <i
                                    className='fa-solid fa-file mx-2'
                                    style={{ fontSize: '15px' }}
                                  ></i>
                                  View PDF
                                </a>
                              </Form.Text>
                            ) : (
                              selectedFiles && (
                                <Form.Text className='text-muted mx-2'>
                                  <a
                                    href={URL.createObjectURL(selectedFiles)}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                  >
                                    <i
                                      className='fa-solid fa-file mx-2'
                                      style={{ fontSize: '15px' }}
                                    ></i>
                                    {selectedFiles.name}
                                  </a>
                                </Form.Text>
                              )
                            )}
                          </>
                        )}

                        {rowData.header === 'VIDEO' && (
                          <>
                            <Form.Group className='mb-3 mx-3'>
                              <Form.Label>Upload Video</Form.Label>{' '}
                              <Form.Text muted>
                                (Video Supported: .mp4)
                              </Form.Text>
                              <Form.Control
                                type='file'
                                name='header_video_url'
                                accept='video/mp4' // Allow only MP4 videos
                                onChange={handleFileChange}
                                isInvalid={!!errors.header_video_url}
                              />
                              <Form.Control.Feedback type='invalid'>
                                {errors.header_video_url}
                              </Form.Control.Feedback>
                              <Form.Text>Maximum Size: 16MB</Form.Text>
                              {errorMessage && (
                                <>
                                  <br />
                                  <Form.Text className='text-danger'>
                                    {errorMessage}
                                  </Form.Text>
                                </>
                              )}
                            </Form.Group>
                            {selectedVideo2 ? (
                              <video
                                controls
                                className='mx-3'
                                style={{ width: '100%' }}
                              >
                                <source src={selectedVideo2} type='video/mp4' />
                                Your browser does not support the video tag.
                              </video>
                            ) : (
                              selectedFiles && (
                                <video
                                  controls
                                  className='mx-3'
                                  style={{ width: '100%' }}
                                >
                                  <source
                                    src={URL.createObjectURL(selectedFiles)}
                                    type='video/mp4'
                                  />
                                  Your browser does not support the video tag.
                                </video>
                              )
                            )}
                          </>
                        )}
                      </Col>
                    </Row>

                    <Row className='mb-3'>
                      <Col lg={12} sm={12} xs={12}>
                        <Form.Group className='mx-3 mb-1'>
                          <div className='d-flex justify-content-between align-items-center'>
                            <Form.Label
                              className='form-view-label'
                              htmlFor='formBasicBody'
                            >
                              Body
                              <OverlayTrigger
                                placement='auto'
                                overlay={
                                  <Popover id={`popover-positioned-auto`}>
                                    <Popover.Body>
                                      <ul>
                                        <li>
                                          Min 25 and max 1,024 characters.
                                        </li>
                                        <li>Cannot end with a variable.</li>
                                      </ul>
                                    </Popover.Body>
                                  </Popover>
                                }
                              >
                                <i
                                  className='fa-solid fa-circle-info text-secondary ms-1'
                                  style={{ cursor: 'pointer' }}
                                ></i>
                              </OverlayTrigger>
                            </Form.Label>

                            <span
                              className='text-muted'
                              style={{ fontSize: '0.85rem' }}
                            >
                              {`${rowData?.message_body?.length || 0}/1024`}
                            </span>
                          </div>

                          <Form.Control
                            as='textarea'
                            name='message_body'
                            ref={bodyRef}
                            value={rowData?.message_body}
                            onChange={handleChange}
                            placeholder='type text here...'
                            required
                            rows={10}
                            maxLength={1024}
                            isInvalid={!!errors.message_body}
                          />
                          <Form.Control.Feedback type='invalid'>
                            {errors.message_body}
                          </Form.Control.Feedback>
                        </Form.Group>

                        <div className='mb-3 mx-3'>
                          <Col
                            lg={12}
                            sm={12}
                            xs={12}
                            className='text-end mb-2'
                          >
                            <button
                              className='format-text-btn'
                              onClick={() => formatTextArea('*')}
                              data-bs-toggle='tooltip'
                              title='Bold'
                            >
                              <i className='fa-solid fa-bold'></i>
                            </button>
                            <button
                              className='format-text-btn'
                              onClick={() => formatTextArea('_')}
                              data-bs-toggle='tooltip'
                              title='Italic'
                            >
                              <i className='fa-solid fa-italic'></i>
                            </button>
                            <button
                              className='format-text-btn'
                              onClick={() => formatTextArea('~')}
                              data-bs-toggle='tooltip'
                              title='Strike-through'
                            >
                              <i className='fa-solid fa-strikethrough'></i>
                            </button>
                            <button
                              className='format-text-btn'
                              onClick={() => formatTextArea('```')}
                              data-bs-toggle='tooltip'
                              title='Monospace'
                            >
                              <i className='fa-solid fa-code'></i>
                            </button>
                            <button
                              onClick={addVariable}
                              className='format-text-btn'
                            >
                              <i className='fa-solid fa-plus'></i>{' '}
                              <span className='fw-bold ps-2'>Add variable</span>
                            </button>
                            {/*<button className='format-text-btn' onClick={() => formatTextArea(null)}><i className="fa-solid fa-plus"></i> <span className='fw-bold ps-2'>Add variable</span></button>*/}
                            <OverlayTrigger
                              placement='auto'
                              overlay={
                                <Popover id={`popover-positioned-auto`}>
                                  <Popover.Body>
                                    <ul>
                                      <li>
                                        Variable parameters are missing or have
                                        mismatched curly braces. The correct
                                        format is &#123;&#123;1&#125;&#125;.
                                      </li>
                                      <li>
                                        Variable parameters should not contain
                                        special characters such as #, $, or %.
                                      </li>
                                      <li>
                                        Variable parameters are not sequential.
                                        For example, &#123;&#123;1&#125;&#125;,
                                        &#123;&#123;2&#125;&#125;,
                                        &#123;&#123;4&#125;&#125;,
                                        &#123;&#123;5&#125;&#125; are defined
                                        but &#123;&#123;3&#125;&#125; does not
                                        exist.
                                      </li>
                                      <li>
                                        Template contains too many variable
                                        parameters relative to the message
                                        length. You need to decrease the number
                                        of variable parameters or increase the
                                        message length.
                                      </li>
                                      <li>
                                        The message template cannot end with a
                                        parameter.
                                      </li>
                                    </ul>
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              <i
                                className='fa-solid fa-circle-info text-secondary'
                                style={{ cursor: 'pointer' }}
                              ></i>
                            </OverlayTrigger>
                          </Col>

                          <Col xs={12}>
                            {rowData?.message_body_example && (
                              <span
                                className='text-muted'
                                style={{ fontSize: '0.85rem' }}
                              >
                                <b> Samples for body content </b> <br />
                                To help us review your message template, please
                                add an example for each variable in your body
                                text. Do not use real customer information.
                                Cloud API hosted by Meta reviews templates and
                                variable parameters to protect the security and
                                integrity of our services.
                              </span>
                            )}
                            {rowData?.message_body_example ? (
                              <Table>
                                <thead>
                                  <tr>
                                    <th className='w-25'>Variable</th>
                                    <th className='w-25'>Value</th>
                                    <th className='w-10'>Remove</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {rowData?.message_body_example?.map(
                                    (example, index) => (
                                      <tr key={index}>
                                        <td>{`{{${example.placeholder}}}`}</td>

                                        <td>
                                          <Form.Control
                                            required
                                            type='text'
                                            name={`${example.placeholder}.value`}
                                            value={example.value || ''}
                                            onChange={e => {
                                              const updatedValue =
                                                e.target.value;
                                              setRowData(prevData => ({
                                                ...prevData,
                                                message_body_example:
                                                  prevData.message_body_example.map(
                                                    item =>
                                                      item.placeholder ===
                                                      example.placeholder
                                                        ? {
                                                            ...item,
                                                            value: updatedValue,
                                                          }
                                                        : item
                                                  ),
                                              }));
                                            }}
                                            placeholder={`Enter content for {{${example.placeholder}}}`}
                                            isInvalid={
                                              !!errors[
                                                `body_var_${example.placeholder}`
                                              ]
                                            } // 👈 key part
                                          />
                                          <Form.Control.Feedback type='invalid'>
                                            {
                                              errors[
                                                `body_var_${example.placeholder}`
                                              ]
                                            }
                                          </Form.Control.Feedback>
                                        </td>
                                        <td>
                                          <Button
                                            className='mt-2'
                                            variant='danger'
                                            size='sm'
                                            onClick={() =>
                                              handleRemoveVariable(
                                                example.placeholder
                                              )
                                            }
                                            title='Remove variable'
                                          >
                                            <i className='fa-solid fa-xmark'></i>
                                          </Button>
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </Table>
                            ) : (
                              ''
                            )}
                          </Col>
                        </div>
                      </Col>
                      <Col lg={6} sm={12} xs={12}>
                        <Form.Group className='mx-3 mb-3'>
                          <div className='d-flex justify-content-between align-items-center'>
                            <div>
                              <Form.Label
                                className='form-view-label'
                                htmlFor='formBasicFooter'
                              >
                                Footer
                              </Form.Label>
                              <OverlayTrigger
                                placement='auto'
                                overlay={
                                  <Popover id={`popover-positioned-auto`}>
                                    <Popover.Body>
                                      <ul className='mb-0'>
                                        <li>Max 60 characters.</li>
                                        <li>No newlines or emojis.</li>
                                      </ul>
                                    </Popover.Body>
                                  </Popover>
                                }
                              >
                                <i
                                  className='fa-solid fa-circle-info text-secondary ms-1'
                                  style={{ cursor: 'pointer' }}
                                ></i>
                              </OverlayTrigger>
                            </div>
                            <span
                              className='text-muted'
                              style={{ fontSize: '0.85rem' }}
                            >
                              {`${rowData?.footer?.length || 0}/60`}
                            </span>
                          </div>
                          <Form.Control
                            type='text'
                            name='footer'
                            value={rowData?.footer}
                            onChange={handleChange}
                            placeholder='type text here...'
                            maxLength={60}
                            isInvalid={!!errors.footer}
                          />
                          <Form.Control.Feedback type='invalid'>
                            {errors.footer}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className='mb-1'>
                      <Col lg={12} sm={12} xs={12}>
                        <Button
                          className='mb-3 mx-3'
                          variant='primary'
                          onClick={handleAddButton}
                        >
                          <i className='fa-solid fa-plus mx-1'></i>Add Button
                        </Button>
                        <small className='text-muted m-1'>
                          Add quick reply buttons like <b>STOP</b>,{' '}
                          <b>Unsubscribe</b>, <b>OPT OUT</b>, <b>Remove Me</b>,
                          or <b>No, i am not interested</b> so users can easily
                          opt out instead of blocking/reporting your number.
                        </small>
                      </Col>
                    </Row>

                    <Row className='mb-1 mx-2'>
                      <Col lg={12} sm={12} xs={12} className='mb-2'>
                        {buttons.map((button, index) => (
                          <Row key={index} className='mb-3'>
                            <Col lg={3} sm={12} xs={12}>
                              <Form.Group className='mb-0'>
                                <Form.Label className='form-view-label'>
                                  Type of action
                                </Form.Label>
                                <Form.Select
                                  value={button.type}
                                  onChange={e =>
                                    handleButtonChange(
                                      index,
                                      'type',
                                      e.target.value
                                    )
                                  }
                                >
                                  <option value=''>Select Type</option>
                                  <option
                                    value='URL'
                                    disabled={
                                      getDisabledOptions('URL') &&
                                      button.type !== 'URL'
                                    }
                                  >
                                    Visit Website
                                  </option>
                                  <option
                                    value='PHONE_NUMBER'
                                    disabled={
                                      getDisabledOptions('PHONE_NUMBER') &&
                                      button.type !== 'PHONE_NUMBER'
                                    }
                                  >
                                    Call Phone Number
                                  </option>
                                  <option value='QUICK_REPLY'>
                                    Quick Reply
                                  </option>
                                </Form.Select>
                              </Form.Group>
                            </Col>

                            {(button.type === 'URL' ||
                              button.type === 'PHONE_NUMBER') && (
                              <Col lg={3} sm={12} xs={12}>
                                <Form.Group className='mb-0'>
                                  <Form.Label className='form-view-label'>
                                    Button Text
                                  </Form.Label>
                                  <Form.Control
                                    required
                                    type='text'
                                    value={button.text}
                                    onChange={e =>
                                      handleButtonChange(
                                        index,
                                        'text',
                                        e.target.value
                                      )
                                    }
                                    isInvalid={!!errors[`button_${index}_text`]}
                                    placeholder='Enter button text...'
                                  />
                                  <Form.Control.Feedback type='invalid'>
                                    {errors[`button_${index}_text`]}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            )}

                            {button.type === 'URL' && (
                              <Col lg={4} sm={12} xs={12}>
                                <Form.Group className='mb-0'>
                                  <Form.Label className='form-view-label'>
                                    URL
                                  </Form.Label>
                                  <Form.Control
                                    required
                                    type='text'
                                    value={button.url}
                                    onChange={e =>
                                      handleButtonChange(
                                        index,
                                        'url',
                                        e.target.value
                                      )
                                    }
                                    placeholder='https://www.example.com'
                                    isInvalid={!!errors[`button_${index}_url`]} // ✅
                                  />
                                  <Form.Control.Feedback type='invalid'>
                                    {errors[`button_${index}_url`]}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            )}

                            {button.type === 'PHONE_NUMBER' && (
                              <>
                                <Col lg={2} sm={6} xs={6}>
                                  <Form.Group className=''>
                                    <Form.Label className='form-view-label'>
                                      Country Code
                                    </Form.Label>
                                    <Form.Select
                                      name='country_code'
                                      value={button.country_code || '+91'}
                                      onChange={e =>
                                        handleButtonChange(
                                          index,
                                          'country_code',
                                          e.target.value
                                        )
                                      }
                                    >
                                      {CountryCode.map((country, index) => (
                                        <option
                                          key={index}
                                          value={country.country_code}
                                        >
                                          {country.country} (
                                          {country.country_code})
                                        </option>
                                      ))}
                                    </Form.Select>
                                  </Form.Group>
                                </Col>

                                <Col lg={2} sm={6} xs={6}>
                                  <Form.Group className='mb-0'>
                                    <Form.Label className='form-view-label'>
                                      Phone Number
                                    </Form.Label>
                                    <Form.Control
                                      required
                                      type='text'
                                      value={button.phone_number}
                                      onChange={e =>
                                        handleButtonChange(
                                          index,
                                          'phone_number',
                                          e.target.value.replace(/\D/g, '')
                                        )
                                      }
                                      placeholder='16467043595'
                                      isInvalid={
                                        !!errors[`button_${index}_phone`]
                                      } // ✅
                                    />
                                    <Form.Control.Feedback type='invalid'>
                                      {errors[`button_${index}_phone`]}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </Col>
                              </>
                            )}

                            {button.type === 'QUICK_REPLY' && (
                              <Col lg={7} sm={12} xs={12}>
                                <Form.Group className='mb-0'>
                                  <Form.Label className='form-view-label'>
                                    Text
                                  </Form.Label>
                                  <Form.Control
                                    required
                                    type='text'
                                    value={button.text}
                                    onChange={e =>
                                      handleButtonChange(
                                        index,
                                        'text',
                                        e.target.value
                                      )
                                    }
                                    placeholder='Enter button text...'
                                    maxLength={25}
                                    isInvalid={!!errors[`button_${index}_text`]} // ✅
                                  />
                                  <Form.Control.Feedback type='invalid'>
                                    {errors[`button_${index}_text`]}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            )}

                            <Col
                              lg={2}
                              sm={12}
                              xs={12}
                              className='d-flex align-items-center mt-4 pt-2 '
                            >
                              <Button
                                variant='danger'
                                onClick={() => handleRemoveButton(index)}
                              >
                                <i
                                  className='fa-solid fa-xmark'
                                  title='Remove'
                                ></i>
                              </Button>
                            </Col>
                          </Row>
                        ))}
                      </Col>
                    </Row>

                    <Row>
                      <Col lg={12} sm={12} xs={12}>
                        <hr></hr>
                      </Col>
                    </Row>

                    <Row className='g-0 mb-2'>
                      <Col lg={12} sm={12} xs={12} className='text-end mt-2'>
                        <Button
                          className='mx-2'
                          variant='light'
                          onClick={handleBack}
                          disabled={isSending}
                        >
                          Back
                        </Button>
                        <Button
                          variant='primary'
                          disabled={isSending}
                          onClick={handleSubmit}
                        >
                          {isSending ? 'Submitting...' : 'Submit for Review'}
                        </Button>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </>
      ) : (
        <Container className='mt-1'>
          <Row className='mx-5'>
            <Col lg={12} sm={12} xs={12}>
              <Card className='h-100' style={{ border: 'none' }}>
                <Card.Body>
                  <Row className='mb-3'>
                    <Col lg={12} sm={12} xs={12}>
                      <div className='sk-cube-grid'>
                        <div className='sk-cube sk-cube1'></div>
                        <div className='sk-cube sk-cube2'></div>
                        <div className='sk-cube sk-cube3'></div>
                        <div className='sk-cube sk-cube4'></div>
                        <div className='sk-cube sk-cube5'></div>
                        <div className='sk-cube sk-cube6'></div>
                        <div className='sk-cube sk-cube7'></div>
                        <div className='sk-cube sk-cube8'></div>
                        <div className='sk-cube sk-cube9'></div>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      )}

      <ToastContainer />
    </>
  );
};

export default MarketingTemplate;
